import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DummyPhoto from '../../images/icons/dummy_image.jpeg';
import EditDetailsMOB from '../../images/icons/edit.svg';
import RightArrow from '../../images/icons/right_arrow.svg';
import { getBasicDetails } from '../../common/constants/api';
import DummyCertificate from '../../images/icons/dummy_certificate.jpeg';
import './certificate.css';
import FincityImage from '../../images/icons/fincity.png';
import BG from '../../images/icons/certificate.png';
import moment from 'moment';

class PartnerProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profilePic: DummyPhoto,
      profileName: 'NA',
      partnerJoined: 'NA',
      partnerID: 'NA',
      certificate: DummyCertificate,
      Constitution: 'NA',
      phone_no: 'NA',
      dob: 'NA',
      gender: 'NA',
      email: 'NA',
      phone_no_editor: false,
      email_editor: false,
      view_certificate: ''
    };
    this.main_container = React.createRef();
    this.sub_container = React.createRef();
  }

  componentDidMount() {
    getBasicDetails().then(data => {
      let data_keys = [
        {
          key: 'profileName',
          value: 'name'
        },
        { key: 'email', value: 'email' },
        { key: 'dob', value: 'dob' },
        { key: 'partnerJoined', value: 'joined_date' },
        { key: 'certificate', value: 'certificate' },
        { key: 'profilePic', value: 'pic' },
        { key: 'partnerID', value: 'partnerCode' },
        { key: 'Constitution', value: 'Constitution' },
        { key: 'gender', value: 'gender' },
        { key: 'phone_no', value: 'phone' }
      ];

      for (let i = 0; i < data_keys.length; i++) {
        if (data_keys[i]['key'] === 'profileName') {
          let first_name = data.name.firstName ? data.name.firstName : '';
          let middele_name = data.name.middleName ? data.name.middleName : '';
          let last_name = data.name.lastName ? data.name.lastName : '';

          this.setState({
            profileName: first_name + ' ' + middele_name + ' ' + last_name
          });
        } else {
          if (data_keys[i]['key'] == 'dob' && data[data_keys[i]['value']]) {
            let year = moment(data[data_keys[i]['value']]).year();
            let month =
              parseInt(moment(data[data_keys[i]['value']]).month()) + 1;
            let date = moment(data[data_keys[i]['value']]).date();
            let full_date =
              date && month && year ? date + '/' + month + '/' + year : 'NA';
            this.setState({
              [data_keys[i]['key']]: full_date
            });
          } else if (data[data_keys[i]['value']]) {
            this.setState({
              [data_keys[i]['key']]: data[data_keys[i]['value']]
            });
          } else {
            // this.setState({ [data_keys[i]['key']]: dummy_data_value[i] });
          }
        }
      }
    });
  }

  componentWillReceiveProps(nextProps) {}

  componentWillUpdate(nextProps, nextState) {}

  componentDidUpdate(prevProps, prevState) {}

  componentWillUnmount() {}

  render() {
    const ViewCertificate = () => {
      // this.sub_container.current.style.display = 'block'
      this.setState({ view_certificate: true });
    };
    const CloseCertificateView = () => {
      this.sub_container.current.style.display = 'none';
    };

    return (
      <>
        {!this.state.view_certificate ? (
          <div className="w-full block">
            <div
              className=" w-12/12 bg-green-600 h-64 md:bg-white md:hidden "
              ref={this.main_container}
              style={{
                borderBottomRightRadius: '30%',
                borderBottomLeftRadius: '30%'
              }}
            ></div>

            <div className=" -mt-24 md:mt-0 w-10/12 md:w-full block py-5 bg-white rounded-lg  mx-auto md:flex">
              <div className="w-full md:w-4/12 text-center mx-auto  ">
                <div className="w-full mx-auto text-center md:mt-0 ">
                  <img
                    className="-mt-24 md:mt-0 md:w-24 md:h-24 w-32 h-32  mx-auto rounded-full"
                    src={this.state.profilePic}
                    alt="Profilr pic"
                  />
                </div>
                <div className="w-full text-center mt-5">
                  <p className="text-base text-center font-robot font-medium text-black-0">
                    {this.state.profileName}
                  </p>
                  <p className="hidden md:block text-xs text-center font-robot font-normal text-grey-1200 mt-2 opacity-75">
                    Business Partner Since <br />
                    {this.state.partnerJoined}
                  </p>
                  <div className="block md:hidden w-full text-center">
                    <p className="text-sm text-center font-robot font-normal text-black-0">
                      Partner ID #{this.state.partnerID}
                    </p>
                    <img
                      className="w-4 mx-auto -mt-4 float-right mr-3 -mt-10"
                      src={EditDetailsMOB}
                      alt="edit details"
                      onClick={() =>
                        this.setState({
                          phone_no_editor: true,
                          email_editor: true
                        })
                      }
                    />
                  </div>
                  <div className="w-full text-center mx-auto mt-4">
                    <img
                      className="w-12 mx-auto"
                      src={this.state.certificate}
                      alt="certificate"
                    />
                    <a
                      className="text-center font-robot font-normal text-grey-970 text-xs hover:underline cursor-pointer"
                      onClick={ViewCertificate}
                    >
                      View Certificate
                    </a>
                  </div>
                </div>
              </div>

              <div className=" w-full md:w-8/12 text-center mx-auto mt-6 md:mt-20">
                <div className="w-full md:w-10/12 mx-auto">
                  <table className="w-9/12 mx-auto md:w-10/12 text-grey-970 text-sm font-robot font-normal text-left ">
                    <tbody>
                      <tr className="leading-10">
                        <td className="w-6/12 sm:3/12 md:w-3/12 lg:w-4/12">
                          Partner <span className="float-right">:</span>
                        </td>
                        <td className="w-6/12 float-right  sm:w-11/12 md:w-11/12 lg:w-11/12 whitespace-normal break-all">
                          {this.state.partnerID}
                        </td>
                      </tr>

                      <tr className="leading-10">
                        <td className="w-6/12 sm:3/12 md:w-3/12 lg:w-4/12">
                          Constitution <span className="float-right">:</span>
                        </td>
                        <td className="w-6/12 float-right   sm:w-11/12 md:w-11/12 lg:w-11/12 break-all ">
                          {this.state.Constitution}
                        </td>
                      </tr>
                      <tr className="leading-10">
                        <td className="w-6/12 sm:3/12 md:w-3/12 lg:w-4/12">
                          Phone <span className="float-right">:</span>
                        </td>
                        <td className="w-6/12 float-right   sm:w-11/12 md:w-11/12 lg:w-11/12 break-all">
                          <div className="w-full md:w-11/12">
                            {this.state.phone_no_editor ? (
                              <input
                                className="border-b border-green-800  w-full"
                                autoFocus
                                type="number"
                                value={this.state.phone_no}
                                onChange={() =>
                                  this.setState({
                                    phone_no: event.target.value
                                  })
                                }
                              />
                            ) : (
                              this.state.phone_no
                            )}
                          </div>
                          <div className="hidden md:block w-1/12">
                            {/* <img
                              className="w-full"
                              src={EditDetailsMOB}
                              alt="edit detail"
                              onClick={() =>
                                this.setState({ phone_no_editor: true })
                              }
                            /> */}
                          </div>
                        </td>
                      </tr>
                      <tr className="leading-10 ">
                        <td className="w-6/12 sm:3/12 md:w-3/12 lg:w-4/12">
                          Email <span className="float-right">:</span>
                        </td>
                        <td className="w-6/12 float-right  sm:w-11/12 md:w-11/12 lg:w-11/12 break-all">
                          <div className="w-full md:w-11/12">
                            {this.state.email_editor ? (
                              <input
                                className="border-b border-green-800  w-full"
                                autoFocus
                                type="email"
                                value={this.state.email}
                                onChange={() =>
                                  this.setState({ email: event.target.value })
                                }
                              />
                            ) : (
                              this.state.email
                            )}
                          </div>
                          <div className="hidden md:block w-1/12">
                            {/* <img
                              className="w-full"
                              src={EditDetailsMOB}
                              alt="edit detail"
                              onClick={() =>
                                this.setState({ email_editor: true })
                              }
                            /> */}
                          </div>
                        </td>
                      </tr>
                      <tr className="leading-10">
                        <td className="w-6/12 sm:3/12 md:w-3/12 lg:w-4/12">
                          Date Of Birth <span className="float-right">:</span>
                        </td>
                        <td className="w-6/12 float-right sm:w-11/12 md:w-11/12 lg:w-11/12  break-all">
                          {this.state.dob}
                        </td>
                      </tr>
                      <tr className="leading-10">
                        <td className="w-6/12 sm:3/12 md:w-3/12 lg:w-4/12">
                          Gender <span className="float-right">:</span>
                        </td>
                        <td className="w-6/12 float-right sm:w-11/12 md:w-11/12 lg:w-11/12 break-all">
                          {this.state.gender}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="w-full md:hidden mt-5 px-3">
                <div className="w-full border-b border-grey-980 items-center flex">
                  <p className="w-9/12 text-base font-roboto font-normal text-grey-980 pt-6 pb-4 pl-4 text-left">
                    PAN CARD
                  </p>
                  <div className="w-3/12 mr-5 pt-6 pb-4 ml-auto">
                    <img className="w-3 float-right " src={RightArrow} />
                  </div>
                </div>
                <div className="w-full border-b border-grey-980 items-center flex">
                  <p className="w-9/12 text-base font-roboto font-normal text-grey-980 pt-6 pb-4 pl-4 text-left">
                    {' '}
                    AADHAR CARD
                  </p>
                  <div className="w-3/12 mr-5 pt-6 pb-4 ml-auto">
                    <img className="w-3 float-right " src={RightArrow} />
                  </div>
                </div>
                <div className="w-full border-b border-grey-980 items-center flex">
                  <p className="w-9/12 text-base font-roboto font-normal text-grey-980 pt-6 pb-4 pl-4 text-left">
                    {' '}
                    ADDRESS PROOF{' '}
                  </p>
                  <div className="w-3/12 mr-5 pt-6 pb-4 ml-auto">
                    <img className="w-3 float-right " src={RightArrow} />
                  </div>
                </div>
                <div className="w-full border-b border-grey-980 items-center flex">
                  <p className="w-9/12 text-base font-roboto font-normal text-grey-980 pt-6 pb-4 pl-4 text-left">
                    {' '}
                    BANK DETAILS
                  </p>
                  <div className="w-3/12 mr-5 pt-6 pb-4 ml-auto">
                    <img className="w-3 float-right " src={RightArrow} />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="hidden w-10/12 mx-auto text-center"
              ref={this.sub_container}
              style={{ position: 'absolute', top: '30%', left: '8.5%' }}
            >
              <p
                className="text-sm text-black text-right cursor-pointer"
                onClick={CloseCertificateView}
              >
                Close
              </p>
              <img className="w-full mx-auto" src={this.state.certificate} />
              <a
                className="w-full mt-3 text-base font-robot font-normal text-green-600 text-center"
                href={this.state.certificate}
                download
              >
                Download
              </a>
            </div>
          </div>
        ) : (
          <>
            <div className="w-11/12 certificate  my-10 bg-contain mx-auto">
              <div className="w-full mx-auto">
                <div className="w-5/12 mx-auto mt-10 ">
                  <img
                    className=" mx-auto image_cell "
                    src={FincityImage}
                    style={{ width: '4vw' }}
                  />
                  <h1
                    className="uppercase text-3xl font-roboto font-normal text-black-0 text-center mx-auto certificate_header"
                    style={{ fontSize: '1.5vw' }}
                  >
                    certificate
                  </h1>
                  <p
                    className="uppercase text-xs  font-roboto font-normal text-grey-970 text-center mx-auto font-medium certificate_title "
                    style={{ fontSize: '0.8vw' }}
                  >
                    OF EMPANELLMENT
                  </p>
                </div>

                <div
                  className="w-5/12 mx-auto custom_style "
                  style={{ marginTop: '8%' }}
                >
                  <p
                    className="uppercase text-xs  font-roboto font-normal text-grey-970 text-center mx-auto certificate_init"
                    style={{ fontSize: '0.7rem' }}
                  >
                    This Certificate is Proudly Presented to
                  </p>
                </div>
                <div
                  className="w-6/12 mx-auto text-center custom_style"
                  style={{ marginTop: '4%' }}
                >
                  <p className="w-full uppercase text-xs italic  font-roboto font-normal text-black-0 text-center mx-auto border-b">
                    {this.state.profileName}
                  </p>
                </div>
                <div className="w-4/12 mx-auto text-center partner_quote_container">
                  <p
                    className="w-full  text-sm  font-roboto  font-normal text-grey-970 text-center mx-auto partner_quote "
                    style={{ fontSize: '0.6vw' }}
                  >
                    For Getting Successfully Empanelled as a Business Partner to
                    Finicty and Partner Code being {this.state.partnerID}
                  </p>
                </div>
                <div
                  className="w-5/12 mx-auto text-center flex mb-2 certificate_footer"
                  style={{ marginTop: '2.5vw' }}
                >
                  <p
                    className="w-2/12 text-center pt-1 text-xs  font-roboto font-normal text-grey-970 ml-4 mx-auto border-t footer_content"
                    style={{ fontSize: '0.6vw' }}
                  >
                    Issued On
                  </p>
                  <p
                    className="w-2/12 text-center pt-1 text-xs  font-roboto font-normal text-grey-970 ml-4 mx-auto border-t footer_content"
                    style={{ fontSize: '0.6vw' }}
                  >
                    Partner ID
                  </p>
                  <p
                    className="w-2/12 text-center pt-1 text-xs  font-roboto font-normal text-grey-970 ml-4 mx-auto border-t footer_content"
                    style={{ fontSize: '0.6vw' }}
                  >
                    Signature
                  </p>
                </div>
              </div>
            </div>
            <p
              className=" text-base text-grey-970 px-4 cursor-pointer"
              onClick={() => this.setState({ view_certificate: false })}
            >
              X
            </p>
          </>
        )}
      </>
    );
  }
}

PartnerProfile.propTypes = {};

export default PartnerProfile;
